export function initPopularityData(percent, can) {
    let c = can.getContext('2d');

    let posX = can.width / 2,
        posY = can.height / 2,
        fps = 1000 / 500,
        procent = 0,
        oneProcent = 360 / 100,
        result = oneProcent * percent;

    c.lineCap = 'round';
    arcMove();

    function arcMove(){
        let deegres = 0;
        let acrInterval = setInterval (function() {
            deegres += 1;
            c.clearRect( 0, 0, can.width, can.height );
            procent = deegres / oneProcent;


            c.beginPath();
            c.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 + 360) );
            c.strokeStyle = 'rgba(230, 230, 230, 0.5)';
            c.lineWidth = '10';
            c.stroke();

            c.beginPath();
            c.strokeStyle = '#181818';
            c.lineWidth = '10';
            c.arc( posX, posY, 70, (Math.PI/180) * 270, (Math.PI/180) * (270 - deegres), true );
            c.stroke();
            if( deegres >= result ) clearInterval(acrInterval);
        }, fps);

    }
}